import React, { Component } from 'react'
import Uppy from '@uppy/core';
import { Dashboard } from '@uppy/react'
import Transloadit from '@uppy/transloadit';
import '@uppy/core/dist/style.css'
import '@uppy/drag-drop/dist/style.css';
import { baseUrl, TOAST_ERROR } from '../../../../../../../utils';
import { UPPY_AWS_KEY, UPPY_AWS_SECRET_KEY, UPPY_BUCKET, UPPY_CAMPAION_URL, UPPY_KEY } from '../../../../../../../actions/constant';

const uppyKey = UPPY_KEY;
const uppyBucket =  UPPY_BUCKET;
const uppyAwsKey =  UPPY_AWS_KEY;
const uppyAwsSecret =  UPPY_AWS_SECRET_KEY;

class DropZone extends Component {
    constructor(props) {
        super(props);

        this.uppyOne = new Uppy({
            debug: true, autoProceed: true, restrictions: {
                maxFileSize: 5000000, maxNumberOfFiles: 1, minNumberOfFiles: 1, allowedFileTypes: ['.csv'],
            }
        }).use(Transloadit, {
            target: '#a',
            params: {
                auth: {
                    key: uppyKey
                },
                steps: {
                    store: {
                        robot: "/wasabi/store",
                        bucket_region: "us-west-1",
                        bucket: uppyBucket,
                        key: uppyAwsKey,
                        secret: uppyAwsSecret,
                        path: 'media/tmpimages/${file.id}'
                    },
                }
            },
            waitForEncoding: true
        });
    }


    componentDidMount() {
        this.uppyOne.on('transloadit:result', (stepName, result) => {
            this.props.onUploadSuccess(result.original_name, result.url);
            this.uppyOne.cancelAll()
        });
        this.uppyOne.on("restriction-failed", (file, error) => {

            let fileType = file.type.split('/');

            if (fileType[0] != 'csv') {
                TOAST_ERROR("You can only upload csv File")
                return false
            }


            if (file.size > 5000000) {
                TOAST_ERROR("Maximum allowed size of 4.8 MB")
                return false
            }

        });
    }

    componentWillUnmount() {
        this.uppyOne.cancelAll()
        this.uppyOne.close({ reason: 'unmount' })
    }

    render() {
        const { fileName } = this.props;

        return <div className="bulkURL-box mb-2">
            <p>Download the <a href={baseUrl("sample/csv-sample.csv")} target="_self" className="text-link">Sample CSV template</a> to see an example of the format required</p>
            <Dashboard
                proudlyDisplayPoweredByUppy={false}
                hideUploadButton={false}
                showProgressDetails={false}
                disableThumbnailGenerator={false}
                height={200}
                width={'100%'}
                showSelectedFiles={true}
                showRemoveButtonAfterComplete={false}
                disableInformer={true}
                uppy={this.uppyOne}
            />
            <div className="selected-file">
                {fileName}
            </div>
        </div>

    }
}


export default DropZone